import { Modal, Form, Input, Alert } from 'antd'
import React from 'react'
import toClass from 'recompose/toClass'

const FormItem = Form.Item

const SMSActivationComponent = (props: any) => {
  const { form, editingRecord, ...rest } = props
  const { getFieldDecorator } = form

  return (
    <Modal {...rest} okText="Activate">
      <Form layout="vertical">
        <FormItem label="Phone number to SMS test after successful activation. This parameter is optional.">
          {getFieldDecorator('phoneNumber', {})(<Input />)}
        </FormItem>
        <FormItem>
          <Alert
            message="Careful!"
            description="This action will activate the SMS channel using a shared Large Account. 
            If you need to configure an exclusive Large Account, please contact Consulting team."
            type="warning"
            showIcon/>
        </FormItem>
      </Form>
    </Modal>
  )
}

export const SMSActivationModal = Form.create({
  mapPropsToFields: record => Object.keys(record).reduce((xs, x) => ({ ...xs, [x]: Form.createFormField({ value: record[x] }) }), {}),
})(toClass(SMSActivationComponent))
